import { useQuery } from '@tanstack/react-query';
import { fetchChangelogVersions } from '../../common/utils/changelog-versions.util';

/** Where the editor's changelog is served from, under /public. */
export const NXT_CHANGELOG_PATH = '/changelog-nxt.md';

/**
 * The version of the NXT Editor this store is offering.
 *
 * Read from the changelog rather than written down beside it. The framework
 * derives its download's filename the same way and for the same reason: a
 * version pinned in package.json goes stale the moment the archive moves, and
 * it did - the framework's said 1.10.2 long after 1.10.2 was gone, and every
 * download since arrived wearing the wrong version.
 *
 * The editor has no per-version history here - the server holds one archive
 * and serves it as nxt_latest.zip - so there is no release list to read a
 * version off either. What there is is the changelog, and a release is written
 * up there because somebody decided it was worth offering. Making that the one
 * edit per release is better than a second place to forget.
 *
 * Null while it is being fetched, and null if it cannot be read: callers show
 * nothing rather than a version they are guessing at.
 */
export const useNxtVersion = (): { version: string | null } => {
  const query = useQuery({
    queryKey: ['nxt-changelog-versions'],
    queryFn: async () => fetchChangelogVersions(NXT_CHANGELOG_PATH)
  });
  // Newest first, the way the file is written.
  return { version: query.data?.[0] ?? null };
};
